module["exports"] = [
  "###",
  "##",
  "#"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/address/building_number.js
 ** module id = 674
 ** module chunks = 0
 **/